import { createWithSms } from "../../visitWidgetApi";
import { AppDispatch } from "@store/store";
import { logInfo } from "@lib/logger";
import { authTokenSuccessAction } from "./authTokenSuccessAction";

export interface VerifySmsLoginOtpActionParams {
  phone: string;
  temporarySmsToken: string;
  confirmationCode: string;
}

/*
 * Verify SMS login OTP
 */
const verifySmsLoginOtpAction =
  ({
    phone,
    temporarySmsToken,
    confirmationCode,
  }: VerifySmsLoginOtpActionParams) =>
  async (dispatch: AppDispatch) => {
    try {
      const response = await createWithSms(
        phone,
        temporarySmsToken,
        confirmationCode,
      );
      await dispatch(authTokenSuccessAction({ authToken: response.authToken }));
    } catch (error) {
      logInfo(error);
      throw error;
    }
  };

export { verifySmsLoginOtpAction };
